import ticketApi from "@api/ticket";
import { useMutation } from "@tanstack/react-query";


const useRefundTickets = (orderUuid: string) => {
    return useMutation({
        mutationFn: async (ticketsUuids: string[]) => {
            return await ticketApi.refundTicket(orderUuid, ticketsUuids)
        },
    })
}

export default useRefundTickets;